import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import Button, { ButtonVariant } from '@/components/button';
import TextInput from '@/components/input/textInput';

export type StepOneFormData = {
  email: string;
};

const initialValue: StepOneFormData = {
  email: '',
};

const schema = yup.object({
  email: yup
    .string()
    .email('Must be a valid email')
    .required('This is a required field'),
});

type Props = {
  formId: string;
  isLoading: boolean;
  handleContinue: (data: StepOneFormData) => void;
};

const LoginStepOneForm: React.FC<Props> = ({
  formId,
  isLoading,
  handleContinue,
}) => {
  const { handleSubmit, control } = useForm({
    defaultValues: initialValue,
    resolver: yupResolver(schema),
  });

  return (
    <form id={formId} onSubmit={handleSubmit(handleContinue)}>
      <TextInput
        required
        className="w-full"
        control={control}
        label="Email"
        name="email"
        placeholder="Email"
      />
      <div className="flex flex-col gap-y-4">
        <Button
          form={formId}
          isLoading={isLoading}
          type="submit"
          variant={ButtonVariant.PRIMARY}
        >
          Continue
        </Button>
      </div>
    </form>
  );
};

export default LoginStepOneForm;
